import { Button, ui } from '@/components/ui';
import { toast } from 'sonner';
import s from './Mfa.module.css';

// Shown once, right after they are made. The server only keeps hashes.
export function RecoveryCodes({ codes, onDone }: { codes: string[]; onDone: () => void }) {
  const text = codes.join('\n');
  const download = () => {
    const url = URL.createObjectURL(new Blob([`Fairvero recovery codes\n\n${text}\n`]));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'fairvero-recovery-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div className={ui.stack}>
      <p>
        <strong>Save these recovery codes now.</strong> If you lose your phone, each code lets you
        sign in once. You won’t see them again.
      </p>
      <ul className={s.codes}>
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      <div className={ui.row}>
        <Button
          variant="secondary"
          onClick={() => {
            void navigator.clipboard.writeText(text).then(() => toast.success('Codes copied'));
          }}
        >
          Copy
        </Button>
        <Button variant="secondary" onClick={download}>
          Download
        </Button>
        <Button onClick={onDone}>I’ve saved them</Button>
      </div>
    </div>
  );
}
